import React from 'react'
import { ApplicationsSettingsForm } from './form'
import { OrganizationApplicationsSettingsRequests } from './organization-applications-settings-requests'

interface OrganizationApplicationsSettingsFormProps {
  organizationUuid: string
}

export function OrganizationApplicationsSettingsForm({
  organizationUuid
}: OrganizationApplicationsSettingsFormProps) {
  return (
    <OrganizationApplicationsSettingsRequests
      organizationUuid={organizationUuid}
    >
      {({
        organizationID,
        numberOfLicensesUsed,
        numberOfLicensesAvailable,
        availableCompliancePolicies,
        availableRemediationPolicies,
        autoLicense,
        filterAppMostRecentSession,
        preventOnboardingFailingApplications,
        preventOnboardingFailingApplicationsBySession,
        protectRuleEnv,
        routeExpirationDays,
        remediationPolicies,
        compliancePolicies,
        importance,
        customMetadataFields,
        customMetadataSettings,
        updateSettings
      }) => (
        <ApplicationsSettingsForm
          numberOfLicensesAvailable={numberOfLicensesAvailable}
          numberOfLicensesUsed={numberOfLicensesUsed}
          availableRemediationPolicies={availableRemediationPolicies.filter(
            (p) => p.enabled
          )}
          availableRemediationNotifyPolicies={availableRemediationPolicies.filter(
            (p) => p.enabled && p.action === 'NOTIFY'
          )}
          availableRemediationAutoRemediatePolicies={availableRemediationPolicies.filter(
            (p) => p.enabled && p.action === 'AUTO_REMEDIATE'
          )}
          availableCompliancePolicies={availableCompliancePolicies.filter(
            (p) => p.enabled
          )}
          initialSettings={{
            autoLicense,
            filterAppMostRecentSession,
            preventOnboardingFailingApplications,
            preventOnboardingFailingApplicationsBySession,
            protectRuleEnv,
            routeExpirationDays,
            remediationPolicies,
            compliancePolicies,
            importance,
            customMetadata: {
              fields: customMetadataFields,
              settings: customMetadataSettings
            }
          }}
          organizationID={organizationID}
          onSubmit={async ({
            autoLicense,
            filterAppMostRecentSession,
            preventOnboardingFailingApplications,
            preventOnboardingFailingApplicationsBySession,
            protectRuleEnv,
            routeExpirationDays,
            importance,
            compliancePolicies,
            remediationPolicies,
            customMetadata
          }) => {
            const {
              settings: { newAppAction, existingAppAction },
              fields
            } = customMetadata

            const metadata = {
              fields,
              newAppAction,
              existingAppAction
            }

            await updateSettings({
              variables: {
                organizationID,
                autoLicense,
                filterAppMostRecentSession,
                preventOnboardingFailingApplications,
                preventOnboardingFailingApplicationsBySession,
                protectRuleEnv,
                routeExpirationDays,
                importance,
                remediationPolicies: remediationPolicies.map((p) => p.id),
                compliancePolicies: compliancePolicies.map((p) => p.id),
                customMetadata: metadata
              },
              optimisticResponse: {
                __typename: 'Mutation',
                updateOrganizationApplicationsSettings: {
                  id: organizationID,
                  __typename: 'OrganizationApplicationsSettings',
                  autoLicense,
                  filterAppMostRecentSession,
                  preventOnboardingFailingApplications,
                  preventOnboardingFailingApplicationsBySession,
                  protectRuleEnv,
                  routeExpirationDays,
                  importance,
                  remediationPolicies: remediationPolicies.map((policy) => ({
                    ...policy,
                    __typename: 'RemediationPolicy'
                  })),
                  compliancePolicies: compliancePolicies.map((policy) => ({
                    ...policy,
                    __typename: 'CompliancePolicy'
                  }))
                }
              }
            })

            // TODO: add analytic 'org.settings.application.save'
          }}
        />
      )}
    </OrganizationApplicationsSettingsRequests>
  )
}
